import { Polygon, MultiPolygon, Point, MultiPoint, LineString, MultiLineString, GeometryCollection } from "geojson";
import { OsmSearchJsonV2 } from "../services/common/osm.type";
import type { PaginatedCitiesQuery, SortOrder } from "@/types/gql/graphql";

export type Geometry = Point | MultiPoint | LineString | MultiLineString | Polygon | MultiPolygon | GeometryCollection;

export type City = PaginatedCitiesQuery["paginatedCities"]["results"][number];

export interface CityOptions {
  offstreet: boolean;
  live: boolean;
  payment: boolean;
  curbZones: boolean;
  mapIntegration: boolean;
  mobileMap?: boolean;
  decreeAnalysis?: CityDecreeAnalysis;
  wazeFeedUrl?: string;
}

export interface CityDecreeAnalysis {
  enabled: boolean;
  emailFrom?: string;
  emailTo?: string;
}

export interface Currency {
  code: string;
  symbol?: string;
}

/** City as fetched for listing. */
export type SimplifiedCity = Pick<City, "name" | "id" | "zipCode" | "position">;

/** The part of the city to be filled by hand. */
export type PromptCity = Pick<City, "name" | "zipCode">;

export type CitiesFilter = {
  name: string;
  wikidata?: string;
};

export interface CreateCityParam extends OsmSearchJsonV2, PromptCity {}

export type CityResponse = {
  city: City;
};

export type CityInput = {
  name: string;
  zipCode: string;
  departement: string;
  state: string;
  country: string;
  countryCode: string;
  surfaceArea: string;
  dataProviderName: string;
  deviceIds: { device: string }[];
  latitude: string;
  longitude: string;
  boundaries: string;
  currency: Currency;
  options?: CityOptions;
  timezone?: string;
};

export type PagedResult<T> = {
  results: T[];
  totalPages: number;
};

export interface PaginationParams {
  pageIndex: number;
  pageSize: number;
}

export interface FilterParams extends PaginationParams {
  sortField?: string;
  sortOrder?: SortOrder;
}

export const initPage: PaginationParams = {
  pageIndex: 1,
  pageSize: 25,
};
